import { render, staticRenderFns } from "./staffs.vue?vue&type=template&id=dc83caa2&"
import script from "./staffs.vue?vue&type=script&lang=js&"
export * from "./staffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports